export default __webpack_public_path__ + "static/hurdle_bg-55fe118eb090d010d6f4d899a11e2469.png";